import {
  modifyPostLike,
  mergeListOfPosts,
  modifyPostComments,
  modifyPostCommentCount,
  incrementSinglePostTips,
  modifySinglePostComments,
  modifySinglePostCommentCount,
  modifySinglePostBookmarkStatus,
  updateSinglePostLike,
  modifyPostBookmarkStatus,
  modifyPostHasStoryStatus,
  modifyPostOnUpdate,
  modifySinglePostOnUpdate,
  modifySinglePostHasStoryStatus, 
  modifySinglePostOnSubscribedToPerformer,
  replaceUpdatePost,
  modifyPostOnSubscribedToPerformer
} from "../../components/helper/Utils";
import {
  SAVE_POST_START,
  SAVE_POST_SUCCESS,
  SAVE_POST_FAILURE,
  FETCH_POSTS_START,
  FETCH_POSTS_SUCCESS,
  FETCH_POSTS_FAILURE,
  UPDATE_USER_POST_LIKE,
  UPDATE_USER_POST_COMMENTS,
  UPDATE_USER_POST_COMMENT_COUNT,
  UPDATE_USER_POST_BOOKMARK_STATUS,
  FETCH_SINGLE_POST_START,
  FETCH_SINGLE_POST_SUCCESS,
  FETCH_SINGLE_POST_FAILURE,
  DELETE_POST_START,
  DELETE_POST_SUCCESS,
  DELETE_POST_FAILURE,
  CHANGE_POST_STATUS_START,
  CHANGE_POST_STATUS_SUCCESS,
  CHANGE_POST_STATUS_FAILURE,
  SAVE_REPORT_POST_FAILURE,
  SAVE_REPORT_POST_SUCCESS,
  FETCH_REPORT_POSTS_FAILURE,
  FETCH_REPORT_POSTS_START,
  FETCH_REPORT_POSTS_SUCCESS,
  SAVE_REPORT_POST_START,
  PPV_PAYMENT_PAYPAL_START,
  PPV_PAYMENT_PAYPAL_SUCCESS,
  PPV_PAYMENT_PAYPAL_FAILURE,
  INCREMENT_SINGLE_POST_TIPS_COUNT,
  UPDATE_SINGLE_POST_LIKES,
  UPDATE_SINGLE_POST_COMMENTS,
  UPDATE_SINGLE_POST_COMMENTS_COUNT,
  UPDATE_SINGLE_POST_BOOKMARK_STATUS,
  UPDATE_SINGLE_POST_HAS_STORY_STATUS,
  POST_PAYMENT_STRIPE_START,
  POST_PAYMENT_STRIPE_SUCCESS,
  POST_PAYMENT_STRIPE_FAILURE,
  POST_PAYMENT_WALLET_START,
  POST_PAYMENT_WALLET_SUCCESS,
  POST_PAYMENT_WALLET_FAILURE,
  SET_SINGLE_POST,
  UPDATE_USER_POST_HAS_STORY_STATUS,
  SUBSCRIBE_TO_PLAN_SUCCESS,
  UPDATE_POST,
  UPDATE_POST_SUCCESS,
  UPDATE_POST_TRAVELING_LOCATION_START,
  UPDATE_POST_TRAVELING_LOCATION_SUCCESS,
  UPDATE_POST_TRAVELING_LOCATION_FAILURE,
  SET_USER_POST,
  GENERATE_POST_PREVIEW_START,
  GENERATE_POST_PREVIEW_SUCCESS,
  GENERATE_POST_PREVIEW_FAILURE,
  ACCEPT_POST_COLLABORATION,
  ACCEPT_POST_COLLABORATION_SUCCESS,
  ACCEPT_POST_COLLABORATION_FAILED,
  DECLINE_POST_COLLABORATION,
  DECLINE_POST_COLLABORATION_SUCCESS,
  DECLINE_POST_COLLABORATION_FAILED
} from "../actions/ActionConstant";

const initialState = {
  savePost: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  updatePost: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  updatePostTravelingLocation: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
  },
  posts: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  singlePost: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  delPost: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  changePostStatus: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  fileUpload: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  ppvPayStripe: {
    inputData: {},
    loading: true,
    error: false,
    success: {},
    buttonDisable: false,
    loadingButtonContent: null,
  },
  reportPosts: {
    data: {},
    loading: true,
    error: false,
  },
  saveReportPost: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  postPaymentStripe: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  postPaymentWallet: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  generatePostPreview: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
  },
  acceptPostCollaboration: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    buttonDisable: false,
  },
  declinePostCollaboration: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    buttonDisable: false,
  },
};

const PostReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_POST_START:
      return {
        ...state,
        savePost: {
          data: {},
          error: false,
          loading: true,
          buttonDisable: true,
          inputData: action.data,
          loadingButtonContent: "Uploading... Please wait",
        },
      };
    case SAVE_POST_SUCCESS:
      return {
        ...state,
        savePost: {
          error: false,
          inputData: {},
          loading: false,
          data: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SAVE_POST_FAILURE:
      return {
        ...state,
        savePost: {
          data: {},
          loading: false,
          inputData: {},
          error: action.error,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case UPDATE_POST:
      return {
        ...state,
        updatePost: {
          data: {},
          error: false,
          loading: true,
          buttonDisable: true,
          inputData: action.data,
          loadingButtonContent: "Updating ...",
        },
      };
    case FETCH_POSTS_START:
      return {
        ...state,
        posts: {
          ...state.posts,
          loading: true,
          error: false,
          inputData: action.data,
        },
      };
    case FETCH_POSTS_SUCCESS:
      const currentPosts = state.posts?.data?.data || [];
      const fetchedPosts =
        action.data && action.data.data ? action.data.data : [];
      return {
        ...state,
        posts: {
          data: {
            ...action.data,
            data: mergeListOfPosts(currentPosts, fetchedPosts),
          },
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case FETCH_POSTS_FAILURE:
      return {
        ...state,
        posts: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
        },
      };
    case UPDATE_USER_POST_LIKE:
      return {
        ...state,
        posts: {
          ...state.posts,
          data: {
            ...state.posts.data,
            data: modifyPostLike(state.posts?.data?.data, action.data),
          },
        },
      };
    case UPDATE_USER_POST_COMMENTS:
      return {
        ...state,
        posts: {
          ...state.posts,
          data: {
            ...state.posts.data,
            data: modifyPostComments(state.posts?.data?.data, action.data),
          },
        },
      };
    case UPDATE_USER_POST_COMMENT_COUNT:
      return {
        ...state,
        posts: {
          ...state.posts,
          data: {
            ...state.posts.data,
            data: modifyPostCommentCount(state.posts?.data?.data, action.data),
          },
        },
      };
    case UPDATE_USER_POST_BOOKMARK_STATUS:
      return {
        ...state,
        posts: {
          ...state.posts,
          data: {
            ...state.posts.data,
            data: modifyPostBookmarkStatus(state.posts?.data?.data, action.data),
          },
        },
      };
    case SET_SINGLE_POST:
      const currentPostId = state.singlePost.data?.post?.post_id;
      const newPostId = action.data?.post?.post_id;
      const shouldUpdate = currentPostId && newPostId && 
        currentPostId.toString() === newPostId.toString();
      
      return {
        ...state,
        singlePost: {
          ...state.singlePost,
          data: shouldUpdate ? action.data : (action.data || state.singlePost.data)
        },
      };
    case FETCH_SINGLE_POST_START:
      return {
        ...state,
        singlePost: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
        },
      };
    case FETCH_SINGLE_POST_SUCCESS:
      return {
        ...state,
        singlePost: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case FETCH_SINGLE_POST_FAILURE:
      return {
        ...state,
        singlePost: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };

    case DELETE_POST_START:
      return {
        ...state,
        delPost: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
        },
      };
    case DELETE_POST_SUCCESS:
      return {
        ...state,
        delPost: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case DELETE_POST_FAILURE:
      return {
        ...state,
        delPost: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };

    case CHANGE_POST_STATUS_START:
      return {
        ...state,
        changePostStatus: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
        },
      };
    case CHANGE_POST_STATUS_SUCCESS:
      return {
        ...state,
        changePostStatus: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case CHANGE_POST_STATUS_FAILURE:
      return {
        ...state,
        changePostStatus: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case FETCH_REPORT_POSTS_START:
      return {
        ...state,
        reportPosts: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_REPORT_POSTS_SUCCESS:
      return {
        ...state,
        reportPosts: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_REPORT_POSTS_FAILURE:
      return {
        ...state,
        reportPosts: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case SAVE_REPORT_POST_START:
      return {
        ...state,
        saveReportPost: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading... Please wait.",
          buttonDisable: true,
        },
      };
    case SAVE_REPORT_POST_SUCCESS:
      return {
        ...state,
        saveReportPost: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case SAVE_REPORT_POST_FAILURE:
      return {
        ...state,
        saveReportPost: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case PPV_PAYMENT_PAYPAL_START:
      return {
        ...state,
        ppvPayPal: {
          inputData: action.data,
          loading: true,
          error: false,
          success: {},
          buttonDisable: true,
          loadingButtonContent: "Processing.. Please wait...",
        },
      };
    case PPV_PAYMENT_PAYPAL_SUCCESS:
      return {
        ...state,
        ppvPayPal: {
          loading: false,
          error: false,
          success: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case PPV_PAYMENT_PAYPAL_FAILURE:
      return {
        ...state,
        ppvPayPal: {
          loading: true,
          error: action.error,
          success: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case INCREMENT_SINGLE_POST_TIPS_COUNT:
      return {
        ...state,
        singlePost: {
          data: {
            post: incrementSinglePostTips(state.singlePost.data.post),
          },
        },
      };
    case UPDATE_SINGLE_POST_LIKES:
      return {
        ...state,
        singlePost: {
          data: {
            post: updateSinglePostLike(state.singlePost.data.post, action.data),
          },
        },
      };
    case UPDATE_SINGLE_POST_COMMENTS:
      return {
        ...state,
        singlePost: {
          data: {
            post: modifySinglePostComments(
              state.singlePost.data.post,
              action.data
            ),
          },
        },
      };
    case UPDATE_SINGLE_POST_COMMENTS_COUNT:
      return {
        ...state,
        singlePost: {
          data: {
            post: modifySinglePostCommentCount(
              state.singlePost.data.post,
              action.data
            ),
          },
        },
      };
    case UPDATE_SINGLE_POST_BOOKMARK_STATUS:
      return {
        ...state,
        singlePost: {
          data: {
            post: modifySinglePostBookmarkStatus(
              state.singlePost.data.post,
              action.data
            ),
          },
        },
      };
    case UPDATE_SINGLE_POST_HAS_STORY_STATUS:
      return {
        ...state,
        singlePost: {
          data: {
            post: modifySinglePostHasStoryStatus(
              state.singlePost.data.post,
              action.data
            ),
          },
        },
      };
    case POST_PAYMENT_STRIPE_START:
      return {
        ...state,
        postPaymentStripe: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
        },
      };
    case POST_PAYMENT_STRIPE_SUCCESS:
      return {
        ...state,
        postPaymentStripe: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case POST_PAYMENT_STRIPE_FAILURE:
      return {
        ...state,
        postPaymentStripe: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case POST_PAYMENT_WALLET_START:
      return {
        ...state,
        postPaymentWallet: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
          closePaymentModal: false,
        },
      };
    case POST_PAYMENT_WALLET_SUCCESS:
      return {
        ...state,
        postPaymentWallet: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        }
      };
    case POST_PAYMENT_WALLET_FAILURE:
      return {
        ...state,
        unlockContentModal: {
          isOpen: false,
        },
        postPaymentWallet: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case UPDATE_USER_POST_HAS_STORY_STATUS:
      return {
        ...state,
        posts: {
          ...state.posts,
          data: {
            ...state.posts.data,
            data: modifyPostHasStoryStatus(state.posts?.data?.data, action.data),
          },
        },
      }
    case UPDATE_POST_SUCCESS:
      return {
        ...state,
        singlePost: {
          ...state.singlePost,
          data: {
            post: modifySinglePostOnUpdate(
              state.singlePost.data.post,
              action.data
            ),
          },
        },
        posts: {
          ...state.posts,
          data: {
            ...state.posts.data,
            data: modifyPostOnUpdate(state.posts?.data?.data, action.data),
          },
        },
        updatePost : {
          ...state.updatePost,
          buttonDisable: false,
          loadingButtonContent: null,
          data: action.data
        }
      };
    case SUBSCRIBE_TO_PLAN_SUCCESS:
      return {
        ...state,
        singlePost: {
          ...state.singlePost,
          data: {
            ...state.singlePost.data,
            post: modifySinglePostOnSubscribedToPerformer(state.singlePost.data.post, action.data),
          },
        },
        posts: {
          ...state.posts,
          data: {
            ...state.posts.data,
            data: modifyPostOnSubscribedToPerformer(
              state.posts?.data?.data || [],
              action.data
            ),
          },
        },
      }
    case SET_USER_POST:
      return {
        ...state,
        posts: {
          ...state.posts,
          data: {
            ...state.posts.data,
            data: replaceUpdatePost(
              state.posts?.data?.data || [],
              action.data.post
            ),
          },
        },
      }

    case UPDATE_POST_TRAVELING_LOCATION_START:
      return {
        ...state,
        updatePostTravelingLocation: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
        },
      };
    case UPDATE_POST_TRAVELING_LOCATION_SUCCESS:
      return {
        ...state,
        updatePostTravelingLocation: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case UPDATE_POST_TRAVELING_LOCATION_FAILURE:
      return {
        ...state,
        updatePostTravelingLocation: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
        },
      };
    case GENERATE_POST_PREVIEW_START:
      return {
        ...state,
        generatePostPreview: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
        },
      };
    case GENERATE_POST_PREVIEW_SUCCESS:
      return {
        ...state,
        generatePostPreview: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case GENERATE_POST_PREVIEW_FAILURE:
      return {
        ...state,
        generatePostPreview: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
        },
      };
    case ACCEPT_POST_COLLABORATION:
      return {
        ...state,
        acceptPostCollaboration: {
          data: {},
          loading: true,
          error: false,
          inputData: action.payload,
          buttonDisable: true,
        },
      };
    case ACCEPT_POST_COLLABORATION_SUCCESS:
      return {
        ...state,
        acceptPostCollaboration: {
          data: action.payload,
          loading: false,
          error: false,
          inputData: {},
          buttonDisable: false,
        },
      };
    case ACCEPT_POST_COLLABORATION_FAILED:
      return {
        ...state,
        acceptPostCollaboration: {
          data: {},
          loading: false,
          error: action.payload,
          inputData: {},
          buttonDisable: false,
        },
      };
    case DECLINE_POST_COLLABORATION:
      return {
        ...state,
        declinePostCollaboration: {
          data: {},
          loading: true,
          error: false,
          inputData: action.payload,
          buttonDisable: true,
        },
      };
    case DECLINE_POST_COLLABORATION_SUCCESS:
      return {
        ...state,
        declinePostCollaboration: {
          data: action.payload,
          loading: false,
          error: false,
          inputData: {},
          buttonDisable: false,
        },
      };
    case DECLINE_POST_COLLABORATION_FAILED:
      return {
        ...state,
        declinePostCollaboration: {
          data: {},
          loading: false,
          error: action.payload,
          inputData: {},
          buttonDisable: false,
        },
      };
  
    default:
      return state;
  }
};

export default PostReducer;
